export { mapFormFieldsMetadataByPropertyId } from './mapFormFieldsMetadataByPropertyId';
export { transformApiFormField, isValidApiFormField, } from './transformApiFormField';
export { transformApiFormFieldBatch } from './transformApiFormFieldBatch';
export { extractAndTransformFormFields, } from './extractAndTransformFormFields';
/**
 * Maps properties from custom form fields to the format that the
 * registration workflow expects
 * @param formField Custom form field
 * @returns The format that the registration workflow expects
 */
export const mapFormFieldToWorkflow = (formField) => {
    let values;
    if (!formField.value ||
        (formField.type === 'FILE_UPLOAD' && !formField.value.name)) {
        values = [];
    }
    else if (formField.type === 'FILE_UPLOAD') {
        values = [formField.value.name, formField.value.uuid];
    }
    else if (formField.type === 'MULTIPLE_CHECKBOXES') {
        values = formField.value;
    }
    else {
        values = [formField.value];
    }
    return { values, formFieldId: formField.propertyDefinitionId };
};
/**
 * Filters array of form fields with their values uniquely. The first occurrence
 * of a `formFieldId` will be kept.
 * @param formFields Array of form fields that may or may not have reoccurring `formFieldId`s.
 * @returns Set of form fields where each `formFieldId` only occurs once.
 */
export const removeDuplicateFormFields = (formFields) => {
    return formFields.reduce((fields, field) => {
        const existingField = fields.find(({ formFieldId }) => formFieldId === field.formFieldId);
        return existingField ? fields : fields.concat(field);
    }, []);
};
/**
 * Filters out form fields of type MULTIPLE_CHECKBOXES and PICK_LIST that have no options.
 * These field types require items to be renderable, so fields without items should be excluded.
 * @param formFields Array of form fields to filter
 * @returns Array of form fields with invalid option-based fields removed
 */
export const filterFormFieldsWithoutOptions = (formFields) => {
    return formFields.filter((field) => {
        if (field.type === 'MULTIPLE_CHECKBOXES' || field.type === 'PICK_LIST') {
            return field.items && field.items.length > 0;
        }
        // Keep all other field types
        return true;
    });
};
/**
 * Takes existing form field values and maps them to the corresponding custom form fields.
 * @param customFields All the custom form fields available.
 * @param existingFields Custom form fields with values.
 */
export const extractCustomFieldValues = (customFields, existingFields) => {
    return customFields.map((customField) => {
        var _a, _b, _c, _d;
        const existingField = existingFields === null || existingFields === void 0 ? void 0 : existingFields.find((filledField) => filledField.formFieldId === customField.propertyDefinitionId);
        let value;
        if (existingField) {
            if (customField.type === 'FILE_UPLOAD') {
                if ((_a = existingField.values) === null || _a === void 0 ? void 0 : _a.length) {
                    value = {
                        name: existingField.values[0],
                        uuid: existingField.values[1],
                    };
                }
            }
            else if (customField.type === 'MULTIPLE_CHECKBOXES') {
                value = existingField.values.map((v) => {
                    var _a, _b;
                    return (_b = (_a = customField.items) === null || _a === void 0 ? void 0 : _a.find((item) => item.itemId === Number.parseInt(v))) === null || _b === void 0 ? void 0 : _b.itemId;
                });
            }
            else if (customField.type === 'PICK_LIST') {
                value = (_c = (_b = customField.items) === null || _b === void 0 ? void 0 : _b.find((item) => { var _a; return item.itemId === Number.parseInt((_a = existingField.values) === null || _a === void 0 ? void 0 : _a[0]); })) === null || _c === void 0 ? void 0 : _c.itemId;
            }
            else {
                value = (_d = existingField.values) === null || _d === void 0 ? void 0 : _d[0];
            }
        }
        return Object.assign(Object.assign({}, customField), { value });
    });
};
